import { COLORS } from '../../shared/constants';

const PORTAL_GREEN = COLORS.portal;

/** Hider pin = the Bolt Elevation mark, miniaturised, in signal. The brand
 *  mark stays with the hunted (§4.5). */
export function hiderPinEl(): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'pin pin--hider';
  el.innerHTML = `
    <svg width="46" height="46" viewBox="0 0 46 46" aria-label="you (hider)"
         style="filter: drop-shadow(0 2px 6px rgba(232,70,27,0.55));">
      <circle cx="23" cy="23" r="21" fill="${COLORS.signal}" fill-opacity="0.16"/>
      <circle cx="23" cy="23" r="13" fill="${COLORS.signal}" fill-opacity="0.30"/>
      <g transform="translate(12,8) scale(0.66)" fill="none" stroke-linejoin="round">
        <path d="M18 2 L4 18 L12 19 L9 32 L28 14 L18 13 L18 2 Z"
              stroke="${COLORS.bone}" stroke-width="1.4" opacity="0.45"/>
        <path d="M16 8 L8 16 L13 17 L11 26 L24 14 L17 13 L16 8 Z" fill="${COLORS.signal}"/>
      </g>
    </svg>`;
  return el;
}

/** Seeker pin = a bone disc — an agent of the system (§4.5). */
export function seekerPinEl(): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'pin pin--seeker';
  el.innerHTML = `
    <svg width="30" height="30" viewBox="0 0 30 30" aria-label="seeker"
         style="filter: drop-shadow(0 2px 5px rgba(0,0,0,0.55));">
      <circle cx="15" cy="15" r="13" fill="${COLORS.bone}" fill-opacity="0.16"/>
      <circle cx="15" cy="15" r="9" fill="${COLORS.bone}" stroke="${COLORS.slate}" stroke-width="2"/>
      <circle cx="15" cy="15" r="3.4" fill="${COLORS.slate}"/>
    </svg>`;
  return el;
}

/** Portal exit beacon — a green destination marker, fixed-size regardless of
 *  zoom so the 50 ft exit box is unmistakable from across the play area. Shown
 *  to the seeker only once transported (the box itself is role-filtered upstream). */
export function portalExitPinEl(): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'pin pin--portal-exit';
  el.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:2px;pointer-events:none;';
  el.innerHTML = `
    <svg width="40" height="40" viewBox="0 0 40 40" aria-label="portal exit"
         style="filter: drop-shadow(0 2px 6px rgba(76,175,106,0.6));">
      <circle cx="20" cy="20" r="18" fill="${PORTAL_GREEN}" fill-opacity="0.16"/>
      <circle cx="20" cy="20" r="11" fill="${PORTAL_GREEN}" fill-opacity="0.32"/>
      <circle cx="20" cy="20" r="6" fill="${PORTAL_GREEN}" stroke="${COLORS.slate}" stroke-width="2"/>
    </svg>
    <span style="font-family:'JetBrains Mono',ui-monospace,monospace;font-size:9px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:${PORTAL_GREEN};background:rgba(20,23,26,0.88);padding:1px 6px;border-radius:6px;white-space:nowrap;">Exit</span>`;
  return el;
}

/** Slice walk-start pin — a small bone pin, shown on both maps. */
export function thermoPinEl(): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'pin pin--thermo';
  el.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 22 22" aria-label="slice start">
      <circle cx="11" cy="11" r="8" fill="none" stroke="${COLORS.bone}" stroke-width="2"
              stroke-dasharray="3 2" opacity="0.85"/>
      <circle cx="11" cy="11" r="2.5" fill="${COLORS.bone}"/>
    </svg>`;
  return el;
}
